import { SystemLabel } from 'common/comments2/Comments2.types';
import { MetricType } from 'core/util/Aggregate';

export enum MetricId {
    All = 'ALL_REVIEWS',
    Responded = 'RESPONDED',
    Unresponded = 'UNRESPONDED',
    Pending = 'PENDING',
    NotRespondable = 'NOT_RESPONDABLE',
    LocationCount = 'LOCATION_COUNT',
    NoResponseRequired = 'NO_RESPONSE_REQUIRED',
}

export enum ReviewMetric {
    SentimentTrend = 1,
    SentimentBySource,
    ResponseStatus,
    Overview,
    AverageRating,
    TopCategories,
    SentimentBreakdown,
    LocationsCount,
}

export interface MetricResult {
    id: MetricId;
    value: number;
}

export const MetricMetadata: {
    [key in MetricId]?: {
        id: string;
        key: string | undefined;
        label: string;
        type: MetricType;
        hasCompare: boolean;
        tooltip: string;
        percentTooltip?: string;
        isDeltaIncreasePositive?: boolean;
    };
} = {
    [MetricId.All]: {
        id: MetricId.All,
        key: undefined,
        label: 'ALL_REVIEWS',
        type: MetricType.Count,
        hasCompare: false,
        tooltip: 'METRIC_TOOLTIP_ALL_REVIEWS',
    },
    [MetricId.Responded]: {
        id: MetricId.Responded,
        key: String(SystemLabel.Responded),
        label: 'RESPONDED',
        type: MetricType.Count,
        hasCompare: false,
        tooltip: 'METRIC_TOOLTIP_RESPONDED',
        percentTooltip: 'METRIC_TOOLTIP_RESPONDED_PERCENT',
    },
    [MetricId.Unresponded]: {
        id: MetricId.Unresponded,
        key: String(SystemLabel.Unresponded),
        label: 'UNRESPONDED',
        type: MetricType.Count,
        hasCompare: false,
        tooltip: 'METRIC_TOOLTIP_UNRESPONDED',
        percentTooltip: 'METRIC_TOOLTIP_UNRESPONDED_PERCENT',
        isDeltaIncreasePositive: false,
    },
    [MetricId.NotRespondable]: {
        id: MetricId.NotRespondable,
        key: String(SystemLabel.NotRespondable),
        label: 'NOT_RESPONDABLE',
        type: MetricType.Count,
        hasCompare: false,
        tooltip: 'METRIC_TOOLTIP_NOT_RESPONDABLE',
        percentTooltip: 'METRIC_TOOLTIP_NOT_RESPONDABLE_PERCENT',
    },
    [MetricId.Pending]: {
        id: MetricId.Pending,
        key: String(SystemLabel.PendingApproval),
        label: 'PENDING_APPROVAL',
        type: MetricType.Count,
        hasCompare: false,
        tooltip: 'METRIC_TOOLTIP_PENDING_APPROVAL',
        isDeltaIncreasePositive: false,
    },
    [MetricId.NoResponseRequired]: {
        id: MetricId.NoResponseRequired,
        key: String(SystemLabel.NoResponseRequired),
        label: 'NO_RESPONSE_REQUIRED',
        type: MetricType.Count,
        hasCompare: false,
        tooltip: 'METRIC_TOOLTIP_NO_RESPONSE_REQUIRED',
    },
};

export const OverviewMetrics = [
    MetricMetadata[MetricId.All],
    MetricMetadata[MetricId.Responded],
    MetricMetadata[MetricId.Unresponded],
    MetricMetadata[MetricId.NotRespondable],
    MetricMetadata[MetricId.Pending],
    MetricMetadata[MetricId.NoResponseRequired],
];

export enum ElasticMetricTypes {
    AvgRating = 'avg-rating-metrics',
    SentimentBreakdown = 'sentiment-breakdown-metrics',
    TopCategories = 'top-categories-metrics',
    ResponseStatus = 'response-activity-trend',
    SentimentBySource = 'sentiment-by-source',
    SentimentTrend = 'sentiment-trend',
    MetricsOverview = 'metrics-overview',
    Count = 'count',
}
